<template>
  <div id="assets">
    <!-- navbar on top of page -->

    <nav class="navbar navbar-expand-lg navbar-dark topbar">
      <a class="navbar-brand" href="home">
        <img
          src="../assets/img/iLogDPI.png"
          style="float:left;width:80px;height:40px;"
        />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a class="nav-link" href="Dashboard">Dashboard</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="users">Users</a>
          </li>
          <li class="nav-item active">
            <a class="nav-link" href="assets">
              Assets
              <span class="sr-only">(current)</span>
            </a>
          </li>
        </ul>
        <form class="form-inline my-2 my-lg-0">
          <input
            class="form-control mr-sm-2"
            type="search"
            placeholder="Search..."
            aria-label="Search"
            v-model="search"
          />
        </form>
      </div>
      <div v-if="role == 'management'">
        <button
          class="btn btn-outline-success"
          style="margin:5px;"
          data-toggle="modal"
          data-target="#addNewAssetBox"
          @click="
            ;(checkform = false), (hostname = null), (customerName = null)
          "
        >
          Add Asset
        </button>
      </div>
      <button class="btn btn-outline-danger" @click="logout">Logout</button>
    </nav>
    <img
      class="icon-header"
      src="../assets/img/Asset.png"
      width="70px"
      height="70px"
    />

    <div class="container" v-if="role == 'management'">
      <br />

      <table class="table table-striped table-dark" id="cssTable">
        <thead>
          <tr>
            <th scope="col" width="40%">Customer Name</th>
            <th scope="col" width="40%">Hostname</th>
            <th scope="col" colspan="2" width="20%" class="text-center">
              ACTIONS
            </th>
          </tr>
        </thead>

        <tbody
          v-for="assets in filteredUser"
          v-bind:key="assets.id"
          v-bind:href="assets.hostname"
        >
          <tr>
            <td>{{ assets.customerName }}</td>
            <td>{{ assets.hostname }}</td>
            <td>
              <button
                type="button"
                class="btn btn-edit"
                data-toggle="modal"
                data-target="#EditAssetBox"
                @click.prevent="editUser(assets)"
              >
                <img
                  src="../assets/img/editUserIcon.png"
                  width="25px"
                  height="25px"
                />
              </button>

              <!-- Modal -->
              <div
                class="modal fade"
                id="EditAssetBox"
                tabindex="-1"
                role="dialog"
                aria-labelledby="EditAssetBoxTitle"
                aria-hidden="true"
              >
                <div class="modal-dialog" role="document" v-if="checkEditform">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title text-box" id="EditAssetBoxTitle">
                        Edit hostname
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <br />
                      <h5 class="err_text" v-if="assetfailed">
                        You already have this hostname in your organization.
                        Please use another hostname.
                      </h5>
                      <div class="form-group">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id
                              >CustomerName</span
                            >
                          </div>
                          <input
                            name="customerName"
                            class="form-control"
                            v-model="customerName"
                            readonly
                            :class="{
                              'is-invalid': submitted && $v.customerName.$error,
                            }"
                          />

                          <div
                            v-if="submitted && $v.customerName.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.customerName.required"
                              >Customer Name is required</span
                            >
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">Hostname</span>
                          </div>
                          <input
                            name="hostname"
                            class="form-control"
                            v-model="hostname"
                            :class="{
                              'is-invalid': submitted && $v.hostname.$error,
                            }"
                          />

                          <div
                            v-if="submitted && $v.hostname.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.hostname.required"
                              >Hostname is required</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                        @click="checkform = false"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="updateUser"
                      >
                        Save changes
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="modal-dialog text-box"
                  role="document"
                  v-else-if="!checkEditform"
                >
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="SuccessBoxTitle"></h5>

                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <div class="modal-body text-box">
                      <h5>hostname has been change successfully.</h5>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click=";(checkEditform = true), (editPassword = false)"
                      >
                        Ok
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </td>

            <td>
              <div>
                <button
                  type="button"
                  class="btn btn-del"
                  data-toggle="modal"
                  data-target="#DeleteUserBox"
                  @click="delAsset(assets)"
                >
                  <img
                    src="../assets/img/delUserIcon.png"
                    width="25px"
                    height="25px"
                  />
                </button>
                <!-- Modal -->

                <div
                  class="modal fade"
                  id="DeleteUserBox"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="DeleteUserBoxTitle"
                  aria-hidden="true"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5
                          class="modal-title text-box"
                          id="DeleteUserBoxTitle"
                        >
                          Confirm Delete
                        </h5>
                        <button
                          type="button"
                          class="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>

                      <div class="modal-body text-box">
                        Confirm Delete Hostname: {{ hostname }} ?
                      </div>

                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-secondary"
                          data-dismiss="modal"
                          @click="cancelUser"
                        >
                          No
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click.prevent="deleteAsset()"
                          data-dismiss="modal"
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <!-- </div> -->
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal -->

    <div
      class="modal fade"
      id="addNewAssetBox"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addNewAssetBoxTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" v-if="!checkform">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addNewAssetBoxTitle">
              Create a new asset
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div class="form-group">
                <h5>DPI Admin</h5>
                <br />
                <h5 class="err_text" v-if="assetfailed">
                  You already have this hostname in your organization. Please
                  use another hostname.
                </h5>
              </div>
            </div>
            <div class="form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id>Customer Name</span>
                </div>
                <input
                  type="text"
                  v-model="customerName"
                  id="customerName"
                  name="customerName"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.customerName.$error }"
                />

                <div
                  v-if="submitted && $v.customerName.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.customerName.required"
                    >Customer Name is required</span
                  >
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <label class="input-group-text" for="inputGroupSelect01"
                    >Hostname</label
                  >
                </div>
                <input
                  type="text"
                  v-model="hostname"
                  id="hostname"
                  name="hostname"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.hostname.$error }"
                />

                <div class="input-group-append">
                  <label class="input-group-text" for="inputGroupSelect02"
                    >.ilog.ai</label
                  >
                </div>
                <div
                  v-if="submitted && $v.hostname.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.hostname.required">Hostname is required</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button type="button" class="btn btn-primary" @click="addAsset">
              Add Asset
            </button>
          </div>
        </div>
      </div>
      <div class="modal-dialog" role="document" v-else>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="SuccessBoxTitle">
              Create a new asset account
            </h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <h5>The new asset account has been created successfully.</h5>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="cancelUser()"
            >
              Close
            </button>

            <button
              type="button"
              class="btn btn-primary"
              @click="checkform = false"
            >
              Add another asset
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="role == 'user'">
      <br />
      <table class="table table-striped table-dark" id="cssTable">
        <thead>
          <tr>
            <th scope="col" width="30%">Hostname</th>
          </tr>
        </thead>

        <tbody
          v-for="assets in filteredUser"
          v-bind:key="assets.id"
          v-bind:href="assets.hostname"
        >
          <tr v-if="customer_name == assets.customerName">
            <td>{{ assets.hostname }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <br />
  </div>
</template>

<script>
import Vue from 'vue'
import jwtDecode from 'jwt-decode'
import Vuelidate from 'vuelidate'

import firebase from 'firebase/app'
import '@firebase/auth'
import '@firebase/database'
import '@firebase/analytics'

Vue.config.productionTip = false

import { required } from 'vuelidate/lib/validators'
Vue.use(Vuelidate)

const assetsRef = firebase.database().ref('Assets')
const assetsOR = firebase
  .database()
  .ref('Assets')
  .orderByChild('hostname')

export default {
  name: 'assets',
  data() {
    return {
      customerName: '',
      hostname: '',
      assets: [],
      search: '',
      editName: null,
      checkform: false,
      checkEditform: true,
      submitted: false,
      updateAsset: false,
      notUnique: true,
      assetfailed: false,
    }
  },
  validations: {
    customerName: { required },
    hostname: { required },
  },

  created() {
    this.token = sessionStorage.getItem('user-token')
    this.decoded = jwtDecode(this.token)
    this.role = this.decoded.role
    this.customer_name = this.decoded.customer_name

    //Users DB
    assetsOR.on('child_added', (snapshot) => {
      this.assets.push({ ...snapshot.val(), id: snapshot.key })
    })
    assetsOR.on('child_removed', (snapshot) => {
      const deleteUser = this.assets.find((assets) => assets.id == snapshot.key)
      const index = this.assets.indexOf(deleteUser)
      this.assets.splice(index, 1)
    })
    assetsOR.on('child_changed', (snapshot) => {
      const updateUser = this.assets.find((assets) => assets.id == snapshot.key)
      updateUser.hostname = snapshot.val().hostname
      updateUser.customerName = snapshot.val().customerName
    })

    //Assets DB
  },
  computed: {
    filteredUser() {
      return this.assets.filter((assets) => {
        return assets.hostname.toLowerCase().includes(this.search.toLowerCase())
      })
    },
  },
  methods: {
    unique() {
      let hostnameAsset = ''
      for (var x = 0; x < this.assets.length; x++) {
        if (this.updateAsset == false) {
          hostnameAsset = this.hostname + '.ilog.ai'
        } else {
          hostnameAsset = this.hostname
        }
        if (this.assets[x].hostname == hostnameAsset) {
          this.assetfailed = true
          this.notUnique = true
          return
        }
      }
      this.notUnique = false
    },
    addAsset() {
      this.submitted = true

      //stop here if form is invalid

      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.unique()
      if (this.notUnique == false) {
        this.storeAsset()
      }
    },
    storeAsset() {
      assetsRef.push({
        customerName: this.customerName,
        hostname: this.hostname + '.ilog.ai',
      })
      this.checkform = true
      this.cancelUser()
    },
    delAsset(assets) {
      this.editName = assets
      this.hostname = assets.hostname
    },
    deleteAsset() {
      assetsRef.child(this.editName.id).remove()
    },
    editUser(assets) {
      this.editName = assets
      this.hostname = assets.hostname
      this.customerName = assets.customerName
      this.updateAsset = true
    },
    cancelUser() {
      this.editName = null
      this.updateAsset = false
      this.checkEditform = false
      this.assetfailed = false
    },
    updateUser() {
      this.submitted = true

      //stop here if form is invalid
      this.$v.$touch()
      if (this.$v.hostname.$invalid) {
        return
      }

      this.unique()
      if (this.notUnique == false) {
        assetsRef.child(this.editName.id).update({
          hostname: this.hostname,
        })
        this.hostname = ''
        this.customerName = ''
        this.cancelUser()
      }
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(function() {
          // Sign-out successful.
        })
      sessionStorage.removeItem('user-token')
      this.$router.push({
        name: 'login',
      })
    },
  },
}
</script>

<style>
#assets {
  color: #1c2833;
  height: 100%;
  width: 100%;
  position: static;
  background-size: cover;
  text-align: center;
  font: 600 16px/18px 'Open Sans', sans-serif;
}

.topbar {
  position: sticky; /* fixing the position takes it out of html flow - knows
                   nothing about where to locate itself except by browser
                   coordinates */
  left: 0; /* top left corner should start at leftmost spot */
  top: 0; /* top left corner should start at topmost spot */
  width: 100%; /* take up the full browser width */
  z-index: 200; /* high z index so other content scrolls underneath */
  height: 10%; /* define height for content */
  background: #000000; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #434343,
    #000000
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #434343,
    #000000
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
</style>
